export class CssService {
  applyCssOverride(hotelId, hotelTemplateCss) {
    const existingStyle = document.getElementById('custom-css');
    if (existingStyle) {
      existingStyle.remove();
    }

    if (hotelId === 'ffe173f8d8719c9b') {
      const timestamp = new Date().getTime();
      this.overrideCssFile(
        `https://static.guestcentric.net/cdn/wsbdev/wsbdev_css/be.css?v=${timestamp}`,
      );
    } else if (hotelTemplateCss) {
      this.overrideCssFile(hotelTemplateCss);
    }
  }

  overrideCssFile(file) {
    const style = document.createElement('link');
    style.rel = 'stylesheet';
    style.type = 'text/css';
    style.href = file;
    style.id = 'custom-css';
    document.head.appendChild(style);
  }
}
